import psHttp from '@patsnap/common-ps-http';
import { get, toNumber } from 'lodash';
import { coreBasicApiUrlPrefix, coreSearchApiUrlPrefix, chemicalExternalApiPrefix } from 'library-@/config/constants';
const getDatabaseConfig = () => {
    return new Promise((resolve) => {
        const time = new Date().getTime();
        let dataBaseConfig = sessionStorage.getItem('dataBaseConfig');
        // 添加缓存时效
        let dataBaseConfigTime = toNumber(sessionStorage.getItem('dataBaseConfigTime')) || 0;
        const overTime = time - dataBaseConfigTime > 1 * 60 * 60 * 1000;
        if (dataBaseConfig) {
            dataBaseConfig = JSON.parse(dataBaseConfig);
        }
        if (!overTime && dataBaseConfig && dataBaseConfig.patentTypes && dataBaseConfig.patentCountries) {
            resolve(dataBaseConfig);
        } else {
            psHttp({
                method: 'GET',
                url: `${coreBasicApiUrlPrefix}/analytics/db-select/config`,
                headers: {
                    'X-API-Version': '1.0'
                }
            }).then(res => {
                let data = get(res, 'data.data');
                if (data) {
                    dataBaseConfig = data;
                    sessionStorage.setItem('dataBaseConfig', JSON.stringify(dataBaseConfig));
                    sessionStorage.setItem('dataBaseConfigTime', time);
                    resolve(dataBaseConfig);
                }
            });
        }
    });
};

const setDatabase = (data) => {
    return psHttp({
        method: 'POST',
        url: `${coreBasicApiUrlPrefix}/analytics/db-select/set`,
        data,
        headers: {
            'X-API-Version': '1.0'
        }
    });
};

const saveSettingApi = (data = {}) => {
    return psHttp({
        url: `${coreSearchApiUrlPrefix}/srp/setting`,
        method: 'PUT',
        data,
        transformCode: true
    });
};

/*
 chemical 跳转SAVE_QUERY
*/
const saveQuery = (data = {}) => {
    return psHttp({
        url: `${coreBasicApiUrlPrefix}/analytics/web-query`,
        method: 'POST',
        data,
        headers: {
            'X-API-Version': '1.0'
        }
    });
};

/*
 chemical  获取跳转的url
*/
const transferLocation = (data = {}) => {
    return psHttp({
        url: `${chemicalExternalApiPrefix}/transfer/analytics`,
        method: 'POST',
        data
    });
};

const chemicalTransferQueryApi = (data = {}) => {
    return psHttp({
        url: `${coreBasicApiUrlPrefix}/analytics/query/transform`,
        method: 'POST',
        data,
        headers: {
            'X-API-Version': '1.0'
        }
    }).then(({ data }) => {
        return data;
    });
};

export {
    getDatabaseConfig,
    setDatabase,
    saveSettingApi,
    saveQuery,
    transferLocation,
    chemicalTransferQueryApi
};
